import { render, staticRenderFns } from "./BorrarCategoria.vue?vue&type=template&id=64900aa4"
import script from "./BorrarCategoria.vue?vue&type=script&lang=js"
export * from "./BorrarCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports